module.exports = __webpack_public_path__ + "static/media/artsCrafts.ea8c88b5.png";